import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'

const TrademarkClassTypeOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)
  const [categoryOptions, setCategoryOptions] = useState([{ label: 'All', value: 0 }])
  const [category, setCategory] = useState(optionalData.category || 0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)

    api.GET_TRADEMARK_CLASS_TYPES_BY_RECORD_TYPE(
      category,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .sort((a, b) => (a.Name > b.Name ? 1 : -1))
            .map((t) => ({
              Id: t.Id,
              Name: t.Name,
            })),
        })

        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      },
    )

    dispatch({
      type: SET_OPTIONAL_DATA,
      optionalData: {
        category,
      },
    })
  }, [category])

  const getRecordTypeOptions = () => {
    api.GET_ALL_BASIC_LOOKUP_TYPES(
      'TrademarkRecordType',
      (res) => {
        setCategoryOptions([
          { label: 'All', value: '0' },
          ...res
            .sort((a, b) => (a.Name > b.Name ? 1 : -1))
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
        ])
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      },
    )

    api.GET_TRADEMARK_CLASS_TYPES_BY_RECORD_TYPE(
      0,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .sort((a, b) => (a.Name > b.Name ? 1 : -1))
            .map((t) => ({
              Id: t.Id,
              Name: t.Name,
            })),
        })
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getRecordTypeOptions()
  }, [])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Trademark Record Type"
        noPlaceholder
        value={category}
        onChange={(val) => {
          setCategory(val)
        }}
        options={categoryOptions}
      />
      {loading && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default TrademarkClassTypeOptions
